import React, { ReactElement } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

import { ButtonIcon, Flex, Hr } from 'components';

import { DipPageContext, DipPageProps, useDipPage } from 'components/dipPage';

const WrapperScroll = styled('div')`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  overflow-x: auto;
  flex-grow: 1;
`;

const CenteredFlex = styled('div')`
  display: flex;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  height: 100%;
  align-items: center;
`;

const DipPage = ({
  children,
  backLabel = 'Voltar',
  backLink,
  rightContent = <></>,
  centerContent = <></>,
  topBgColor = 'white',
  topBorderColor = 'gray_200',
  position = 'fixed',
  id,
  immersive = true,
}: DipPageProps): ReactElement => {
  const privateLayout = useDipPage(id);

  return (
    <DipPageContext.Provider value={privateLayout}>
      <Flex position={position} left={0} top={0} width="100%" height="100vh" minWidth="100vw" flexDirection="column" zIndex={100} bg={topBgColor}>
        <Flex flexGrow={0} position="relative" justifyContent="space-between" opacity={0.7} minHeight={56}>
          <Flex py={3} px={3}>
            {backLink ? (
              typeof backLink === 'boolean' ? (
                <ButtonIcon
                  size="large"
                  icon="arrowLeft"
                  bg="transparent"
                  color="primary_400"
                  labelColor="black80"
                  label={backLabel}
                  cursor="pointer"
                  onClick={() => window.history.back()}
                />
              ) : (
                <Link to={backLink}>
                  <ButtonIcon
                    size="large"
                    icon="arrowLeft"
                    bg="transparent"
                    color="primary_400"
                    labelColor="black80"
                    label={backLabel}
                    cursor="pointer"
                  />
                </Link>
              )
            ) : (
              <></>
            )}
          </Flex>

          <CenteredFlex>{centerContent}</CenteredFlex>

          <Flex pr={3} alignItems="center">
            {rightContent}
          </Flex>
        </Flex>

        <Hr color={topBorderColor} m={0} />

        <Flex flexGrow={1} position="relative">
          <WrapperScroll data-dipscroll id={id}>
            <Flex flexGrow={1} flexDirection="column" id="dipLayoutContent">
              {children}
            </Flex>
          </WrapperScroll>
        </Flex>
      </Flex>
    </DipPageContext.Provider>
  );
};

export default DipPage;
